import { Injectable } from '@angular/core';
import { AbstractApiV2Service } from '../../../../api/services/abstract-api-v2.service';
import { CustomerVerificationRequestData } from '../interfaces/customer-verification-request-data.interface';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BackendErrorTranslatorService } from '../../../../services/localization/backend-error-translator.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerVerificationRequestsService extends AbstractApiV2Service<CustomerVerificationRequestData> {
    public customFilters = ['parent'];
    public cvrId: string | null = null;
    public note = '';
    public refreshCVRTableSubject: Subject<boolean> = new Subject<boolean>();
    protected resourceName = 'customer-verification-requests';

    constructor(http: HttpClient, backendErrorTranslator: BackendErrorTranslatorService) {
        super(http, backendErrorTranslator);
    }
}
